import React from 'react';
import { motion } from 'framer-motion';
import { QuoteIcon } from 'lucide-react';
import { moreResults } from '../data/testimonials';
export function MoreResults() {
  return <section className="bg-panel py-16 sm:py-20" aria-labelledby="results-title" data-id="element-145" data-mp="28f80yjn3pvsp">
      <div className="mx-auto max-w-5xl px-4" data-id="element-146" data-mp="28ddhl9rhabqq">
        <h2 id="results-title" className="text-center text-3xl font-extrabold text-ink sm:text-4xl" data-id="element-147" data-mp="2d6zvt6dainon">
          Lo que dicen los docentes que ya tienen su Megapack
        </h2>

        <div className="mt-10 grid gap-5 md:grid-cols-2" data-id="element-148" data-mp="2m63gges3vb59">
          {moreResults.map(([initials, name, place, quote], index) => <motion.article key={name} initial={{
          opacity: 0,
          y: 14
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.3,
          delay: index * 0.04,
          ease: [0.23, 1, 0.32, 1]
        }} className={`flex flex-col rounded-xl border border-line bg-cream p-6 ${index === 4 ? 'md:col-span-2' : ''}`} data-id="element-149" data-mp="2r70viihtjp2j" data-mpi={index}>
              <QuoteIcon className="h-6 w-6 text-accent" aria-hidden="true" data-id="element-150" data-mp="3neqxl3cjw7rn" />
              <blockquote className="mt-4 flex-1 text-sm leading-relaxed text-muted" data-id="element-151" data-mp="3ilxu0istj5h5">“{quote}”</blockquote>
              <div className="mt-6 flex items-center gap-3 border-t border-line pt-4" data-id="element-152" data-mp="3do62hpw35ldh">
                <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-md bg-skyDeep text-sm font-extrabold text-white" data-id="element-153" data-mp="38pl4lx4b3ds7">
                  {initials}
                </span>
                <span data-id="element-154" data-mp="58usr1m1m6il">
                  <b className="block text-sm text-ink" data-id="element-155" data-mp="58md51yjcn3p">{name}</b>
                  <small className="text-xs text-muted" data-id="element-156" data-mp="7ynokpygebl">{place}</small>
                </span>
              </div>
            </motion.article>)}
        </div>
      </div>
    </section>;
}